import './bootstrap'
import { createApp, h } from 'vue'
import { createInertiaApp, router } from '@inertiajs/vue3'
import { createPinia } from 'pinia'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { QuillEditor } from '@vueup/vue-quill'
import { useSettingsStore } from './stores/settingsStore'
import CustomStylesApplier from '@/Components/CustomStylesApplier.vue'
import 'media-chrome'
import 'vimeo-video-element'
import 'youtube-video-element'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
// Inkline
import { Inkline, components } from '@inkline/inkline'
import '@inkline/inkline/inkline.scss'
import '../css/main.scss'
// Element UI
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// Animate on Scroll
import AOS from 'aos'
import 'aos/dist/aos.css'
// ApexCharts
import VueApexCharts from 'vue3-apexcharts'
// ScrollTo
import VueScrollTo from 'vue-scrollto'

const appName = 'Climate64'

// We'll expose NProgress globally to allow our useProgressManager to control it
let nprogressInstance = null

// Progress configuration with additional hooks
const progressConfig = {
  color: '#614ae3',
  delay: 250,
  includeCSS: true,
  showSpinner: false,

  // Store reference to NProgress when it's created
  onCreate: function (nprogress) {
    // Expose NProgress globally for our useProgressManager composable
    nprogressInstance = nprogress
    window.NProgress = nprogress

    // Capture the original methods for reference
    window.originalNProgress = {
      start: nprogress.start,
      set: nprogress.set,
      inc: nprogress.inc,
      done: nprogress.done,
      remove: nprogress.remove,
    }
  },
}

createInertiaApp({
  id: 'app',
  resolve: (name) =>
    resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
  title: (title) => {
    // Skip processing if title is empty or undefined
    if (!title) return appName
    // Remove any existing appName instances to prevent duplication
    const cleanTitle = title.replace(new RegExp(` - ${appName}$`), '')
    // Return formatted title
    return `${cleanTitle} | ${appName}`
  },
  // Always use the progress configuration - the useProgressManager composable will handle disabling when needed
  progress: progressConfig,
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
    const pinia = createPinia()

    app
      .use(plugin)
      .use(ZiggyVue, Ziggy)
      .component('CustomStylesApplier', CustomStylesApplier)
      .use(ElementPlus)
      .component('QuillEditor', QuillEditor)
      .use(VueApexCharts)
      .use(VueScrollTo, {
        duration: 1000,
        easing: 'ease',
      })
      .use(Inkline, {
        components,
      })
      .use(pinia)

    const settingsStore = useSettingsStore()

    // Initialize settings
    if (props.initialPage.props.settings) {
      settingsStore.initializeSettings(props.initialPage.props.settings)
    }

    // Check if we're in SSR mode
    if (import.meta.env.SSR) {
      // Apply initial state to pinia store
      pinia.state.value = window.__INITIAL_STATE__
    }

    // Expose router events globally to better control progress behavior
    window.inertiaRouter = router

    // Store original router visit function for reference
    const originalVisit = router.visit

    // Add a hook to prevent progress during video playback
    router.visit = function (...args) {
      // Check if we should block progress
      if (window.blockInertiaProgress === true) {
        // Create a modified version of args[1] (options) that disables progress
        const options = args[1] || {}
        options.progress = false
        args[1] = options
      }

      // Call the original visit function
      return originalVisit.apply(this, args)
    }

    app.mount(el)

    // Initialize AOS after mounting
    AOS.init()

    return app
  },
})
